import * as React from "react";
import { useServerFn } from "@tanstack/react-start";
import { Download, Loader2 } from "lucide-react";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { getInvoicePdf } from "@/lib/invoices.functions";

export function InvoiceDownloadButton({
  orderId,
  variant = "outline",
  size = "sm",
  label = "Download PDF",
}: {
  orderId: string;
  variant?: "outline" | "default" | "ghost";
  size?: "sm" | "default";
  label?: string;
}) {
  const fetchPdf = useServerFn(getInvoicePdf);
  const [busy, setBusy] = React.useState(false);

  async function download() {
    setBusy(true);
    try {
      const res = await fetchPdf({ data: { orderId } });
      const bin = atob(res.base64);
      const bytes = new Uint8Array(bin.length);
      for (let i = 0; i < bin.length; i++) bytes[i] = bin.charCodeAt(i);
      const url = URL.createObjectURL(new Blob([bytes], { type: "application/pdf" }));
      const a = document.createElement("a");
      a.href = url;
      a.download = res.fileName;
      a.click();
      URL.revokeObjectURL(url);
    } catch (error) {
      toast.error(error instanceof Error ? error.message : "Could not generate the PDF.");
    } finally {
      setBusy(false);
    }
  }

  return (
    <Button variant={variant} size={size} onClick={download} disabled={busy}>
      {busy ? <Loader2 className="size-4 animate-spin" /> : <Download className="size-4" />}
      {label}
    </Button>
  );
}
